var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white h-full"},[_c('div',{staticClass:"p-4"},[_c('DepositHistoryWS')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }